import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Input, Select, DatePicker,Upload,Icon} from 'antd';
const FormItem = Form.Item;
import HeadAdd from './head-add';

class HeadForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            serach: {}
        };
    }

    click(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            Object.keys(values).forEach((key, index) => {
                this.state.serach[key] = values[key];
                this.setState(this.state);
            });
        });
        const { handleSerach } = this.props;
        handleSerach(this.state.serach);
    }
    render() {
        //resourceIds是选中的ids  handDeleteResourceByIds是调用的批量删除的方法
        let { addMeta, serachMeta, handleRefresh, addUrl,uploadUrl,resourceIds,handDeleteResourceByIds } = this.props;
      
        const { getFieldDecorator } = this.props.form;
        const propsImg = {
            name: 'file',
            action: uploadUrl,
            onChange(info) {
                if(info!=undefined&&info.file!=undefined&&info.file.response!=undefined){
                    if(info.file.response.code==200){
                        alert("上传成功");
                        handleRefresh();
                    }else{
                        alert("上传失败:"+info.file.response.desc);
                    }
                }
         },
        };
        return (
            <span>
                <Form inline={true} onSubmit={this.click.bind(this)}>
                    {serachMeta.map((meta, index) => {
                        switch (meta.type) {
                            case 'Input': return <FormItem >
                                {getFieldDecorator(meta.field)(<Input key={index} addonBefore={meta.addonBefore} placeholder={meta.placeholder} />)}
                            </FormItem>;
                            case 'Select': return <FormItem label={meta.label}  >
                                {getFieldDecorator(meta.field)(
                                    <Select
                                        allowClear
                                        placeholder={meta.placeholder}
                                        initialValue={meta.initialValue}
                                        style={{ width: meta.width ? meta.width : 200 }}>
                                        {meta.options.map((item, index) => {
                                            return <Option key={index} value={
                                                item.split("|").length > 1 ? item.split("|")[1] : item
                                            }>{
                                                item.split("|").length > 1 ? item.split("|")[0] : item
                                            }</Option>
                                        })}
                                    </Select>)}
                            </FormItem>;
                            case 'DatePicker':
                                return <FormItem label={meta.label}>
                                    {getFieldDecorator(meta.field)(
                                        <DatePicker />)}
                                </FormItem>;
                        }
                    })}
                    {
                        serachMeta.length > 0 ? < FormItem >
                            <Button type="primary" htmlType="submit">搜索</Button>
                        </FormItem> : < FormItem />
                    }
                    {
                        (addMeta!=undefined && addMeta.length > 0) ? <FormItem >
                            <HeadAdd metadata={addMeta} handleRefresh={handleRefresh} url={addUrl} />
                        </FormItem> : <FormItem />
                    }
                    {/* 素材页面上传按钮 */}
                    {
                        (uploadUrl!=undefined && uploadUrl!=null && uploadUrl.length > 0) ? <FormItem > 
                             <Upload {...propsImg}   style={{marginLeft: '10px'}}>
                           <Button type="primary" >
                            <Icon type="upload"/>上传
                          </Button>
                       </Upload>
                    </FormItem>: <FormItem />
                    }
                     {/* 素材页面批量删除按钮 */}
                    {
                        (resourceIds!=undefined && resourceIds!=null ) ? <FormItem > 
                             <Popconfirm 
                                title="确定批量删除？"
                                onConfirm={() => handDeleteResourceByIds(resourceIds)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off"
                                >
                                    
                                <Button type="primary" >
                                    批量删除
                                </Button>
                            </Popconfirm>
                    </FormItem>: <FormItem />
                    }
                    
                    
                </Form>
            </span>

        )
    }
}

export default Form.create()(HeadForm);



// WEBPACK FOOTER //
// ./utils/head.js